import type React from 'react'
import type { NotificationTarget } from '../api/client'
import type { AppAction } from '../types/app'

// openTarget takes her to what a notification is about. An update has no
// screen to go to: the updates sheet opens its own, so it does nothing here.
export function openTarget(target: NotificationTarget, dispatch: React.Dispatch<AppAction>): void {
  if (target.appointment) {
    dispatch({ type: 'OPEN_APPOINTMENT', payload: target.appointment })
  } else if (target.client) {
    dispatch({ type: 'OPEN_CLIENT', payload: target.client })
    dispatch({ type: 'SET_ACTIVE_TAB', payload: 'clients' })
  } else if (target.client_forms) {
    // Forms live on the client's Details tab.
    dispatch({ type: 'OPEN_CLIENT', payload: target.client_forms, tab: 'details' })
    dispatch({ type: 'SET_ACTIVE_TAB', payload: 'clients' })
  } else if (target.reviews) {
    dispatch({ type: 'OPEN_SETTINGS_PANEL', payload: 'reviews' })
  }
}
